import i18n from '../../locales/index'
import restful from '../vuex'
import axios from 'axios'
import { Message, Spin } from 'view-design'

const state = {
  ...restful.states('product'),
  products_all: [],
  wechat_mini_product_display: true,
  front_product_display: true,
  targetSyncId: null
}

const getters = {
  ...restful.getters('product'),
  products_all: (state) => state.products_all,
  wechat_mini_product_display: (state) => state.wechat_mini_product_display,
  front_product_display: (state) => state.front_product_display
}

const actions = {
  ...restful.actions('products'),
  async destroy_all ({ commit }, id) {
    Spin.show()
    await axios.post(`products/destroy_all`)
    Spin.hide()
    Message.success(i18n.t('store_modules_product_1336'))
    const res = await axios.get('products')
    commit('products', res.data)
  },
  async index_all ({ commit }, params) {
    const response = await axios.get('products', { params })
    commit('products_all', response.data)
  },
  async batch_product_display ({ commit }, params) {
    await axios.post('products/batch_product_display', params)
    if (params.platform === 'wechat_mini') {
      commit('wechat_mini_product_display', params.open)
    } else if (params.platform === 'front') {
      commit('front_product_display', params.open)
    }
    Message.success(i18n.t('store_modules_product_1337'))
  },
  async syncToSubShop ({ commit, state }, id) {
    await axios.post(`products/${state.targetSyncId}/sync_to_sub_shop`, {
      target_shop_id: id
    })
    Message.success(i18n.t('store_modules_banner_1315'))
  },
  async syncToSubShops ({ commit, state }, ids) {
    await axios.post(`products/${state.targetSyncId}/sync_to_sub_shops`, {
      target_shop_ids: ids
    })
    Message.success(i18n.t('store_modules_banner_1315'))
  },
  async batchUpdateTaxes ({ commit, state }, data) {
    await axios.post(`/products/batch_update_taxes`, {
      product_ids: data.product_ids,
      tax_ids: data.tax_ids
    })
    Message.success(i18n.t('store_modules_banner_1315'))
  },
}
const mutations = {
  ...restful.mutations('product'),
  products (state, products) {
    state.products = products
  },
  products_all (state, products_all) {
    state.products_all = products_all
  },
  wechat_mini_product_display (state, wechat_mini_product_display) {
    state.wechat_mini_product_display = wechat_mini_product_display
  },
  front_product_display (state, front_product_display) {
    state.front_product_display = front_product_display
  },
  targetSyncId (state, targetSyncId) {
    state.targetSyncId = targetSyncId
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
